import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Subject, finalize } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import Swal from 'sweetalert2';
import { StatusService } from './status.service';
import { AddStatusCerereComponent } from './add-status-cerere/add-status-cerere.component';
import { EditStatusComponent } from './edit-status/edit-status.component';
import { Status } from './status.interface';
import { helper } from 'src/environments/helper';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
    selector: "app-status",
    templateUrl: "./status.component.html",
    styleUrls: ["./status.component.scss"],
})
export class StatusComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    showCard = false;
    activeValue: string = "-1";
    publicValue: string = "-1";

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink =
        environment.interop.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.cerereStatus
            .getCerereStatuses +
        "-dt";

    parameters: { key: string; value: string }[] = [
        { key: "--Alegeți--", value: "-1" },
        { key: "Da", value: "1" },
        { key: "Nu", value: "0" },
    ];

    resetForm() {
        this.activeValue = "-1";
        this.publicValue = "-1";

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }
    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private requestService: StatusService,
        public permissionsService: PermissionsService,
        private cerereStatusService: StatusService
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next("");
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,
            pageLength: 25,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.active = this.activeValue;
                dataTablesParameters.public = this.publicValue;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: "ID",
                    data: "id",
                },
                {
                    title: "Status",
                    data: "name",
                    render: (data: any, type: any, row: any) => {
                        const bgColor = row.bg_color || "";
                        return `<span style="background-color: ${bgColor}; color: white; border-radius: 4px; padding: 3px 10px">${data}</span>`;
                    },
                },
                {
                    title: "Rank",
                    data: "rank_name",
                },
                {
                    title: "Order",
                    data: "order",
                    sortable: true,
                    render: (data: any, type: any, row: any, met: any) => {
                        return `<div class="order-section-dt"> 
                                <button type="button" class="action-btn up-order btn btn-sm btn-primary" ${row.order == 0 ? 'disabled="true"' : ""
                            } (click)="updateStatusOrder(${row.id
                            }, -1)" title="Downside - -1">
                                    <img class="btn-img" src="/assets/icons/down-white.svg" alt="down-order"/>
                                </button>
                                <span class="order">${row.order}</span>
                                <button type="button" class="action-btn down-order btn btn-sm btn-primary" (click)="updateStatusOrder(${row.id
                            }, 1)" title="Up - +1">
                                    <img class="btn-img" src="/assets/icons/up-white.svg" alt="up-order"/>
                                </button>
                            </div>`;

                        // ${
                        //     row.order == row.section_max_order ? 'disabled="true"' : ''
                        // }
                    },
                },
                {
                    title: "Acțiuni",
                    data: null,
                    className: "all",
                    orderable: false,
                    render: (row: any) => {
                        return (
                            `
                            <div class="d-flex align-center justify-content-left">
                                <button class="action-btn edit ms-1">
                                    <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                                </button>
                                <button class="action-btn delete ms-1">
                                    <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
                                </button>
                                <button type="button" class="action-btn update_status_active ms-1 ` +
                            (row.active == true ? "action-success" : "action-danger") +
                            `">
                                        <img class="btn-img" src="` +
                            (row.active == true
                                ? "/assets/icons/check-white.svg"
                                : "/assets/icons/close-white.svg") +
                            `" alt="update_status_active"/>
                                </button>
                                <button type="button" class="action-btn update_status_public ms-1 ` +
                            (row.public_visible == true
                                ? "action-success"
                                : "action-danger") +
                            `">
                                    <img class="btn-img" src="` +
                            (row.public_visible == true
                                ? "/assets/icons/public_white.svg"
                                : "/assets/icons/public_not_white.svg") +
                            `" alt="update_status_public"/>
                                </button>
                            </div>
                        `
                        );
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector("td:last-child");
                const editIcon = lastTd?.querySelector(".edit") as HTMLElement;
                const deleteIcon = lastTd?.querySelector(".delete") as HTMLElement;
                const orderTD = (row as HTMLElement).querySelector("td:nth-child(4)");
                const upOrderInSection = orderTD?.querySelector(
                    ".up-order"
                ) as HTMLElement;
                const downOrderInSection = orderTD?.querySelector(
                    ".down-order"
                ) as HTMLElement;
                const updateStatusActiveIcon = lastTd?.querySelector(
                    ".update_status_active"
                ) as HTMLElement;
                const updateStatusPublicIcon = lastTd?.querySelector(
                    ".update_status_public"
                ) as HTMLElement;

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            "autcom-module.settings.status-cerere.update"
                        )
                    ) {
                        editIcon.style.display = "none";
                    }
                    editIcon.addEventListener("click", () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            "autcom-module.settings.status-cerere.delete"
                        )
                    ) {
                        deleteIcon.style.display = "none";
                    }
                    deleteIcon.addEventListener("click", () => {
                        const { id } = data;
                        this.deleteCerere(id);
                    });
                }

                if (upOrderInSection) {
                    if (
                        !this.permissionsService.hasPermission(
                            "autcom-module.settings.status-cerere.order"
                        )
                    ) {
                        upOrderInSection.style.display = 'none';
                    }
                    upOrderInSection.addEventListener("click", () => {
                        const { id } = data;
                        this.updateStatusOrder(id, -1);
                    });
                }

                if (downOrderInSection) {
                    if (
                        !this.permissionsService.hasPermission(
                            "autcom-module.settings.status-cerere.order"
                        )
                    ) {
                        downOrderInSection.style.display = 'none';
                    }
                    downOrderInSection.addEventListener("click", () => {
                        const { id } = data;
                        this.updateStatusOrder(id, 1);
                    });
                }

                if (updateStatusActiveIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            "autcom-module.settings.status-cerere.update-status"
                        )
                    ) {
                        updateStatusActiveIcon.style.display = "none";
                    }
                    updateStatusActiveIcon.addEventListener("click", () => {
                        const { id } = data;
                        this.changeStatusActive(id);
                    });
                }

                if (updateStatusPublicIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            "autcom-module.settings.status-cerere.update-status"
                        )
                    ) {
                        updateStatusPublicIcon.style.display = "none";
                    }
                    updateStatusPublicIcon.addEventListener("click", () => {
                        const { id } = data;
                        this.changeStatusPublic(id);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddStatusCerereComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: "Status cerere adăugat cu succes.",
                    icon: "success",
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditStatusComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: "Status cerere actualizat cu succes.",
                    icon: "success",
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    deleteCerere(id: number) {
        Swal.fire({
            title: "Sunteți sigur?",
            text: "Nu o să puteți recupera datele odată cu ștergerea lor!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Confirm!",
            cancelButtonText: "Cancel",
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.requestService
                    .deleteStatus(id)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe(() => {
                        this.rerenderDT();
                        Swal.fire({
                            title: "Șters!",
                            text: "Status cerere șters cu succes.",
                            icon: "success",
                            confirmButtonText: "OK",
                        });
                    });
            }
        });
    }

    updateStatusOrder(id: number, index: number) {
        console.log(id, index, "stuff?");

        this.isLoading = true;
        this.cerereStatusService.updateOrder(id, { index }).subscribe(
            () => {
                this.rerenderDT();
                // will need a toast here :) for good times :)
            },
            (err) => {
                this.rerenderDT();
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }

                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: "error",
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                });
            }
        );
    }

    changeStatusActive(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "O să actualizați statusul funcției selectate!",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusActiveAction(id);
            }
        });
    }

    changeStatusActiveAction(id: number) {
        this.isLoading = true;
        console.log(id);
        this.cerereStatusService.changeStatuseActive(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: "Status cerere actualizat cu succes.",
                    icon: "success",
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: "error",
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusActiveAction(id);
                    }
                });
            }
        );
    }

    changeStatusPublic(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "O să actualizați statusul funcției selectate!",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusPublicAction(id);
            }
        });
    }

    changeStatusPublicAction(id: number) {
        this.isLoading = true;
        this.cerereStatusService.changeStatusePublic(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: "Cerere actualizată cu succes.",
                    icon: "success",
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: "error",
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusPublicAction(id);
                    }
                });
            }
        );
    }

    clearCache() {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: helper.swalTextConfig.generalMessages.cleanCache,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.requestService.clearCache().subscribe(() => {
                    this.rerenderDT();
                    Swal.fire({
                        title: helper.swalTextConfig.headers.deleted,
                        text: helper.swalTextConfig.generalMessages.cleanCacheSuccess,
                        icon: "success",
                        confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                    });
                });
            }
        });
    }


}
